import structTypeMap from './structTypeMap';

export default Object.freeze({
  [structTypeMap.structure]: 'Строение',
  [structTypeMap.building]: 'Сооружение',
  [structTypeMap.letter]: 'Литера',
});
